const event = {
  onGoingEvent: 'Ongoing event',
  closedEvent: 'Closed event',
  emptyClosedEvent: 'No closed events yet',
  emptyOnGoingEvent: 'No ongoing events yet',
};

export default event;
